import CardComponent from './CardComponent';

export class EnquiriesFeedback extends CardComponent {}
